var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSnsYoutubeGrey32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM23.6496 12.4532C23.5593 12.12 23.3833 11.8162 23.1392 11.572C22.895 11.3279 22.5912 11.1519 22.258 11.0616C20.2086 10.8111 18.1447 10.6982 16.0803 10.7237C14.0162 10.6991 11.9527 10.8076 9.90253 11.0485C9.57013 11.1433 9.26762 11.3217 9.02395 11.5669C8.78029 11.812 8.60365 12.1156 8.51093 12.4485C8.28662 13.7034 8.1779 14.9762 8.18613 16.2509C8.17776 17.5241 8.28648 18.7954 8.51093 20.0487C8.60132 20.3819 8.77733 20.6856 9.02145 20.9298C9.26558 21.1739 9.56933 21.3499 9.90253 21.4403C11.9519 21.6905 14.0158 21.8034 16.0803 21.7781C18.1444 21.8028 20.2079 21.6943 22.258 21.4533C22.5912 21.363 22.895 21.1871 23.1392 20.9429C23.3833 20.6988 23.5593 20.395 23.6496 20.0617C23.8736 18.8084 23.9823 17.5372 23.9744 16.264C23.9894 14.9862 23.8807 13.71 23.6496 12.4532ZM18.6161 16.2519L14.5095 18.6188V13.8849L18.6161 16.2519Z",
    fill: "#C9CDD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSnsYoutubeGrey32);
export default __webpack_public_path__ + "static/media/icon_sns_youtube_grey_32.e9b6f11a6373c4b911c1d7e878890fec.svg";
export { ForwardRef as ReactComponent };